import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {DashboardBox5} from '../components';

class Dashboard5 extends Component {
	render() {
		const {pageTitle} = this.props;

		return (
			<Fragment>
				<Helmet title={pageTitle}/>
				<DashboardBox5/>
			</Fragment>
		);
	}
}

Dashboard5.defaultProps = {
	pageTitle: 'Dashboard'
};

Dashboard5.propTypes = {
	pageTitle: PropTypes.string
};

export default Dashboard5;